var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAlert } from 'components/alert/AlertStack';
import { useMutation, useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { DealSummaryPanel } from './components/DealSummaryPanel';
import { DealApprovalPane } from './panes/DealApprovalPane';
import { DealChangelogPane } from './panes/DealChangelogPane';
import { DealContactPane } from './panes/DealContactPane';
import { DealInformationPane } from './panes/DealInformationPane';
import { useApolloClient } from '@apollo/client';
import { Button } from 'components/Button';
import { Content } from 'components/Content';
import { MutationForm } from 'components/form/graphql/MutationForm';
import { Header } from 'components/Header';
import { Screen } from 'components/Screen';
import { ScreenBar } from 'components/ScreenBar';
import { TabPanel } from 'components/TabPanel';
import { TabPanelGroup } from 'components/TabPanelGroup';
import { OrderInDealMutation } from 'graphql/Deal/mutations/OrderIndealMutation';
import { UpdateDealMutation } from 'graphql/Deal/mutations/UpdateDealMutation';
import { UpdateDealHeaderMutation } from 'graphql/Deal/mutations/UpdateDealHeaderMutation';
import { React } from 'libs/react';
import { PdfDownloadButton } from 'components/PdfDownloadButton';
import { Text } from 'components/Text';
import { Money } from 'components/Money';
import { DealAdditionalInformationPane } from './panes/DealAdditionalInformationPane';
import { FieldGroupsQuery } from 'graphql/FieldGroup/queries/FieldGroupsQuery';
import { Requires } from 'components/user/Requires';
import { DealOrderInModal } from './modal/DealOrderInModal';
import { DealTitleModalEdit } from './modal/DealTitleModalEdit';
import { useUser } from 'components/user/UserProvider';
import { useTranslation } from 'components/translation/TranslationProvider';
import { DealApproveModal } from './modal/DealApproveModal';
import { useRoute } from 'components/router/Routing';
import { ExportButton } from 'components/ExportButton';
import { ExportDealsMutation } from 'graphql/Deal/mutations/ExportDealsMutation';
import { FormAction } from 'components/form/FormAction';
import { StatusSelect, getStatusOptions } from 'components/StatusSelect';
import { StageSelect, useDealStageOptions, useHasStagesForStatus } from 'components/StageSelect';
import { RefusalReasonSelect } from 'components/RefusalReasonSelect';
import { DateTime } from 'components/DateTime';
import { formatPlannedDateLabel } from 'helpers/formatPlannedDateLabel';
import { Status } from 'components/Status';
import { useAccount } from 'components/account/AccountProvider';
import { DealDetailsQuery } from 'graphql/Deal/queries/DealDetailsQuery';
import { CreateDealMessageMutation } from 'graphql/Deal/mutations/CreateDealMessageMutation';
import { SendOrderConfirmationMutation } from 'graphql/Order/mutations/SendOrderConfirmationMutation';
import { SendDealInviteMutation } from 'graphql/Deal/mutations/SendDealInviteMutation';
import { DealRejectModal } from './modal/DealRejectModal';
import { DealOrderPane } from './panes/DealOrderPane';
import { OrderVoucherFieldsPanel } from './components/order/OrderVoucherFieldsPanel';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { useDealConfiguratorContext } from './DealConfigureScreen';
import { DealPaymentPanel } from './components/section/payment/DealPaymentPanel';
import { DealCancelOrderModal } from './modal/DealCancelOrderModal';
import { RefundDealPaymentMutation } from 'graphql/Deal/mutations/RefundDealPaymentMutation';
import { DealCancelSignatureModal } from './modal/DealCancelSignatureModal';
import { CancelDealSignatureMutation } from 'graphql/Deal/mutations/CancelDealSignatureMutation';
import { DealReassignOnLoadModal } from './modal/DealReassignOnLoadModal';
import { GenerateTaskListMutation } from 'graphql/TaskList/mutations/GenerateTaskListMutation';
import './DealDetails.scss';
/**
 * @component DealDetailsUpdateScreen
 * @since 1.0.0
 */
export function DealDetails(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36;
    const { id, orderId } = useParams();
    const route = useRoute();
    const { setDeal } = useDealConfiguratorContext();
    const [isOrderIn, setIsOrderIn] = useState(false);
    const [data, ready] = useQuery(DealDetailsQuery, {
        variables: {
            input: {
                id
            }
        }
    });
    const alert = useAlert();
    const user = useUser();
    const apollo = useApolloClient();
    const account = useAccount();
    const { customLabels, language } = useTranslation();
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [openModalApprove, setOpenModalApprove] = useState(false);
    const [openModalReject, setOpenModalReject] = useState(false);
    const [openModalOrderIn, setOpenModalOrderIn] = useState(false);
    const [openModalCancelOrder, setOpenModalCancelOrder] = useState(false);
    const [openModalCancelSignature, setOpenModalCancelSignature] = useState(false);
    const [openModalReassignOnLoad, setOpenModalReassignOnLoad] = useState(false);
    const [dealTitle, setDealTitle] = useState((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.title);
    const [dealStatus, setDealStatus] = useState((_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.status);
    const [dealStage, setDealStage] = useState((_c = data === null || data === void 0 ? void 0 : data.deal) === null || _c === void 0 ? void 0 : _c.stage);
    const [processing, setProcessing] = useState(false);
    const [dealItemFields, setDealItemFields] = useState([]);
    const [dealItemConfigurationFields, setDealItemConfigurationFields] = useState([]);
    const [orderInMutate] = useMutation(OrderInDealMutation);
    const hasPDF = getConfigurationFieldValue((_d = account.configs) !== null && _d !== void 0 ? _d : [], 'HAS_PDF');
    const hasDeposit = getConfigurationFieldValue((_e = account.configs) !== null && _e !== void 0 ? _e : [], 'HAS_DEPOSIT') === 'TRUE';
    const [dataFieldGroup] = useQuery(FieldGroupsQuery, {
        variables: {
            input: {
                query: [
                    {
                        field: 'category',
                        operator: 'in',
                        value: ['DEAL', 'DEAL_ITEM', 'DEAL_ITEM_CONFIGURATION']
                    }
                ]
            }
        }
    });
    const currentOrder = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.deal) === null || _f === void 0 ? void 0 : _f.orders) === null || _g === void 0 ? void 0 : _g.find((order) => order.id === orderId)) !== null && _h !== void 0 ? _h : null;
    const isOrderView = Boolean(orderId);
    useEffect(() => {
        var _a, _b;
        if (dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.fieldGroups) {
            const dealItemFields = (_a = dataFieldGroup.fieldGroups.find((fieldGroup) => fieldGroup.category === 'DEAL_ITEM')) === null || _a === void 0 ? void 0 : _a.fields;
            const dealItemConfigurationFields = (_b = dataFieldGroup.fieldGroups.find((fieldGroup) => fieldGroup.category === 'DEAL_ITEM_CONFIGURATION')) === null || _b === void 0 ? void 0 : _b.fields;
            setDealItemFields(dealItemFields !== null && dealItemFields !== void 0 ? dealItemFields : []);
            setDealItemConfigurationFields(dealItemConfigurationFields !== null && dealItemConfigurationFields !== void 0 ? dealItemConfigurationFields : []);
        }
    }, [dataFieldGroup]);
    // Build external asset data
    const externalDataValues = [];
    const externalData = ((_j = data === null || data === void 0 ? void 0 : data.deal) === null || _j === void 0 ? void 0 : _j.externalData)
        ? JSON.parse((_k = data === null || data === void 0 ? void 0 : data.deal) === null || _k === void 0 ? void 0 : _k.externalData)
        : null;
    if (externalData) {
        for (const [key, value] of Object.entries(externalData)) {
            externalDataValues.push({ asset: key, value: value });
        }
    }
    useEffect(() => {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.deal) {
            setDeal(data === null || data === void 0 ? void 0 : data.deal);
            if ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.orderIn) {
                setIsOrderIn(true);
            }
        }
    }, [data === null || data === void 0 ? void 0 : data.deal]);
    // Check if we need to show the reassign modal on load
    useEffect(() => {
        var _a;
        if ((data === null || data === void 0 ? void 0 : data.deal) && user) {
            const isContactUser = user.isContactUser();
            const isManager = user.isManager();
            const dealUser = data.deal.user;
            const currentUserId = (_a = user.user) === null || _a === void 0 ? void 0 : _a.id;
            // If user is a contactUser but not a manager, and the deal is not assigned to them
            if (isContactUser && !isManager && dealUser && currentUserId) {
                if (dealUser.id !== currentUserId) {
                    setOpenModalReassignOnLoad(true);
                }
            }
        }
    }, [data === null || data === void 0 ? void 0 : data.deal, user]);
    /**
     * @function onClickEdit
     * @since 1.0.0
     * @hidden
     */
    const onClickEdit = () => {
        setOpenModalEdit(true);
    };
    /**
     * @function onCloseEdit
     * @since 1.0.0
     * @hidden
     */
    const onCloseEdit = () => {
        setOpenModalEdit(false);
    };
    /**
     * @function onConfirmEdit
     * @since 1.0.0
     * @hidden
     */
    const onConfirmEdit = (title) => {
        setDealTitle(title);
        onCloseEdit();
    };
    /**
     * @function onClickApprove
     * @since 1.0.0
     * @hidden
     */
    const onClickApprove = () => {
        setOpenModalApprove(true);
    };
    /**
     * @function onCloseApprove
     * @since 1.0.0
     * @hidden
     */
    const onCloseApprove = () => {
        setOpenModalApprove(false);
    };
    /**
     * @function onConfirmApprove
     * @since 1.0.0
     * @hidden
     */
    const onConfirmApprove = () => {
        onSubmitApprove();
        onCloseApprove();
    };
    /**
     * @function onSubmitApprove
     * @since 1.0.0
     * @hidden
     */
    const onSubmitApprove = () => __awaiter(this, void 0, void 0, function* () {
        try {
            if (data === null || data === void 0 ? void 0 : data.deal) {
                yield apollo.mutate({
                    mutation: UpdateDealMutation,
                    variables: {
                        input: {
                            id: data === null || data === void 0 ? void 0 : data.deal.id,
                            status: 'ACTIVE',
                            stage: 'APPROVED',
                            newVersion: false
                        }
                    },
                    refetchQueries: [
                        {
                            query: DealDetailsQuery,
                            variables: {
                                input: {
                                    id: data === null || data === void 0 ? void 0 : data.deal.id
                                }
                            }
                        }
                    ]
                });
                alert.present({
                    title: React.createElement("p", null, t('This deal was approved.'))
                });
            }
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onClickReject
     * @since 1.0.0
     * @hidden
     */
    const onClickReject = () => {
        setOpenModalReject(true);
    };
    /**
     * @function onCloseReject
     * @since 1.0.0
     * @hidden
     */
    const onCloseReject = () => {
        setOpenModalReject(false);
    };
    /**
     * @function onConfirmReject
     * @since 1.0.0
     * @hidden
     */
    const onConfirmReject = (message) => {
        onSubmitReject(message);
        onCloseReject();
    };
    /**
     * @function onSubmitReject
     * @since 1.0.0
     * @hidden
     */
    const onSubmitReject = (message) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (data === null || data === void 0 ? void 0 : data.deal) {
                yield apollo.mutate({
                    mutation: CreateDealMessageMutation,
                    variables: {
                        input: {
                            dealId: data === null || data === void 0 ? void 0 : data.deal.id,
                            message: message
                        }
                    },
                    refetchQueries: [
                        {
                            query: DealDetailsQuery,
                            variables: {
                                input: {
                                    id: data === null || data === void 0 ? void 0 : data.deal.id
                                }
                            }
                        }
                    ]
                });
                alert.present({
                    title: React.createElement("p", null, t('Changes needed sent.'))
                });
            }
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onClickOrderIn
     * @since 1.0.0
     * @hidden
     */
    const onClickOrderIn = () => {
        setOpenModalOrderIn(true);
    };
    /**
     * @function onCloseOrderIn
     * @since 1.0.0
     * @hidden
     */
    const onCloseOrderIn = () => {
        setOpenModalOrderIn(false);
    };
    /**
     * @function onConfirmOrderIn
     * @since 1.0.0
     * @hidden
     */
    const onConfirmOrderIn = () => {
        onSubmitOrderIn();
        onCloseOrderIn();
    };
    /**
     * @function onSubmitOrderIn
     * @since 1.0.0
     * @hidden
     */
    const onSubmitOrderIn = () => __awaiter(this, void 0, void 0, function* () {
        var _37, _38, _39;
        const mutationOption = {
            variables: {
                input: {
                    id: (_37 = data === null || data === void 0 ? void 0 : data.deal) === null || _37 === void 0 ? void 0 : _37.id,
                    revert: false
                }
            },
            refetchQueries: [
                {
                    query: DealDetailsQuery,
                    variables: { input: { id: (_38 = data === null || data === void 0 ? void 0 : data.deal) === null || _38 === void 0 ? void 0 : _38.id } }
                }
            ]
        };
        try {
            yield orderInMutate(mutationOption);
            alert.present({
                title: (React.createElement("p", null,
                    React.createElement("strong", null, (_39 = data === null || data === void 0 ? void 0 : data.deal) === null || _39 === void 0 ? void 0 : _39.title),
                    " ",
                    t('has been ordered.')))
            });
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onClickCancelOrder
     * @since 1.0.0
     * @hidden
     */
    const onClickCancelOrder = () => {
        setOpenModalCancelOrder(true);
    };
    /**
     * @function onCloseCancelOrder
     * @since 1.0.0
     * @hidden
     */
    const onCloseCancelOrder = () => {
        setOpenModalCancelOrder(false);
    };
    /**
     * @function onConfirmCancelOrder
     * @since 1.0.0
     * @hidden
     */
    const onConfirmCancelOrder = (refunds) => __awaiter(this, void 0, void 0, function* () {
        yield onSubmitCancelOrder(refunds);
        onCloseCancelOrder();
    });
    /**
     * @function onSubmitCancelOrder
     * @since 1.0.0
     * @hidden
     */
    const onSubmitCancelOrder = (refunds) => __awaiter(this, void 0, void 0, function* () {
        if (!(data === null || data === void 0 ? void 0 : data.deal)) {
            return;
        }
        const refetchQueries = [
            {
                query: DealDetailsQuery,
                variables: { input: { id: data.deal.id } }
            }
        ];
        try {
            yield apollo.mutate({
                mutation: OrderInDealMutation,
                variables: {
                    input: {
                        id: data.deal.id,
                        revert: true
                    }
                },
                refetchQueries: refunds.length === 0 ? refetchQueries : []
            });
        }
        catch (error) {
            alert.present({ error });
            return;
        }
        alert.present({
            title: (React.createElement("p", null,
                React.createElement("strong", null, data.deal.title),
                " ",
                t('has been cancelled.')))
        });
        // Each refund stands alone: one that fails does not undo the cancellation
        // or stop the next one, and it can be retried from the payments tab.
        for (const refund of refunds) {
            try {
                yield apollo.mutate({
                    mutation: RefundDealPaymentMutation,
                    variables: { input: refund }
                });
            }
            catch (error) {
                alert.present({ error });
            }
        }
        if (refunds.length > 0) {
            yield apollo.query({
                query: DealDetailsQuery,
                variables: { input: { id: data.deal.id } },
                fetchPolicy: 'network-only'
            });
        }
    });
    /**
     * @function onClickCancelSignature
     * @since 1.0.0
     * @hidden
     */
    const onClickCancelSignature = () => {
        setOpenModalCancelSignature(true);
    };
    /**
     * @function onCloseCancelSignature
     * @since 1.0.0
     * @hidden
     */
    const onCloseCancelSignature = () => {
        setOpenModalCancelSignature(false);
    };
    /**
     * @function onConfirmCancelSignature
     * @since 1.0.0
     * @hidden
     */
    const onConfirmCancelSignature = () => {
        onSubmitCancelSignature();
        onCloseCancelSignature();
    };
    /**
     * @function onSubmitCancelSignature
     * @since 1.0.0
     * @hidden
     */
    const onSubmitCancelSignature = () => __awaiter(this, void 0, void 0, function* () {
        try {
            if (data === null || data === void 0 ? void 0 : data.deal) {
                yield apollo.mutate({
                    mutation: CancelDealSignatureMutation,
                    variables: {
                        input: {
                            id: data === null || data === void 0 ? void 0 : data.deal.id
                        }
                    },
                    refetchQueries: [
                        {
                            query: DealDetailsQuery,
                            variables: { input: { id: data === null || data === void 0 ? void 0 : data.deal.id } }
                        }
                    ]
                });
                alert.present({
                    title: React.createElement("p", null, t('The signature has been cancelled.'))
                });
            }
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onCloseReassignOnLoad
     * @since 1.0.0
     * @hidden
     */
    const onCloseReassignOnLoad = () => {
        setOpenModalReassignOnLoad(false);
    };
    /**
     * @function onConfirmReassignOnLoad
     * @since 1.0.0
     * @hidden
     */
    const onConfirmReassignOnLoad = () => {
        onSubmitReassignOnLoad();
        onCloseReassignOnLoad();
    };
    /**
     * @function onSubmitReassignOnLoad
     * @since 1.0.0
     * @hidden
     */
    const onSubmitReassignOnLoad = () => __awaiter(this, void 0, void 0, function* () {
        var _40, _41, _42;
        try {
            if ((data === null || data === void 0 ? void 0 : data.deal) && ((_40 = user.user) === null || _40 === void 0 ? void 0 : _40.id)) {
                yield apollo.mutate({
                    mutation: UpdateDealMutation,
                    variables: {
                        input: {
                            id: data === null || data === void 0 ? void 0 : data.deal.id,
                            assignTo: user.user.id,
                            partnerContact: (_41 = user.user.contact) === null || _41 === void 0 ? void 0 : _41.id,
                            newVersion: false
                        }
                    },
                    refetchQueries: [
                        {
                            query: DealDetailsQuery,
                            variables: { input: { id: data === null || data === void 0 ? void 0 : data.deal.id } }
                        }
                    ]
                });
                alert.present({
                    title: (React.createElement("p", null,
                        React.createElement("strong", null, (_42 = data === null || data === void 0 ? void 0 : data.deal) === null || _42 === void 0 ? void 0 : _42.title),
                        ' ',
                        t('has been reassigned to you.')))
                });
            }
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onProcess
     * @since 1.0.0
     * @hidden
     */
    const onProcess = (values) => {
        var _a, _b;
        const { dealTitle } = values;
        const input = {
            id: (_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id,
            title: dealTitle,
            newVersion: false,
            discountType: (_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.discountType
        };
        return {
            variables: {
                input
            },
            refetchQueries: [
                {
                    query: DealDetailsQuery,
                    variables: {
                        input: {
                            id
                        }
                    }
                }
            ]
        };
    };
    /**
     * @function onPressCopy
     * @since 1.0.0
     * @hidden
     */
    const onPressCopy = () => {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id) {
            const baseUrl = window.location.origin;
            navigator.clipboard.writeText(`${baseUrl}/interactive-quote/${data === null || data === void 0 ? void 0 : data.deal.id}`);
            alert.present({
                title: React.createElement("p", null, t('The link of the quote has been copied.'))
            });
        }
    };
    /**
     * @function onPressCopyID
     * @since 1.0.0
     * @hidden
     */
    const onPressCopyID = () => {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id) {
            navigator.clipboard.writeText(data === null || data === void 0 ? void 0 : data.deal.id);
            alert.present({
                title: React.createElement("p", null, t('The ID of the deal has been copied.'))
            });
        }
    };
    /**
     * @function onPressPreview
     * @since 1.0.0
     * @hidden
     */
    const onPressPreview = () => {
        var _a;
        const link = document.createElement('a');
        link.href = route.gen({
            name: 'quote',
            data: { id: (_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id, preview: 'preview' }
        });
        link.target = '_blank';
        link.click();
    };
    /**
     * @function onClickEditDeal
     * @since 1.0.0
     * @hidden
     */
    const onClickEditDeal = () => {
        var _a, _b;
        if ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id) {
            route.replace({
                name: 'deal.configure',
                data: { id: (_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.id }
            });
        }
    };
    /**
     * @function onClickResendOrderConfirmation
     * @since 1.0.0
     * @hidden
     */
    const onClickResendOrderConfirmation = () => __awaiter(this, void 0, void 0, function* () {
        var _43, _44;
        try {
            const orders = isOrderView && currentOrder
                ? [currentOrder]
                : (_44 = (_43 = data === null || data === void 0 ? void 0 : data.deal) === null || _43 === void 0 ? void 0 : _43.orders) !== null && _44 !== void 0 ? _44 : [];
            if (orders.length > 0) {
                for (const order of orders) {
                    yield apollo.mutate({
                        mutation: SendOrderConfirmationMutation,
                        variables: {
                            input: {
                                id: order.id
                            }
                        }
                    });
                }
                alert.present({
                    title: React.createElement("p", null, t('Order confirmation email has been sent.'))
                });
            }
        }
        catch (error) {
            alert.present({ error });
        }
    });
    const onClickSendInvite = () => __awaiter(this, void 0, void 0, function* () {
        var _45;
        if (!((_45 = data === null || data === void 0 ? void 0 : data.deal) === null || _45 === void 0 ? void 0 : _45.id))
            return;
        try {
            yield apollo.mutate({
                mutation: SendDealInviteMutation,
                variables: { input: { id: data.deal.id } }
            });
            alert.present({
                title: React.createElement("p", null, t('Calendar invite has been sent.'))
            });
        }
        catch (error) {
            alert.present({ error });
        }
    });
    /**
     * @function onClickGenerateManufacturing
     * @since 1.0.0
     * @hidden
     */
    function onClickGenerateManufacturing() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id))
                    return;
                yield apollo.mutate({
                    mutation: GenerateTaskListMutation,
                    variables: {
                        input: {
                            deal: (_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.id
                        }
                    },
                    refetchQueries: [
                        {
                            query: DealDetailsQuery,
                            variables: {
                                input: {
                                    id: (_c = data === null || data === void 0 ? void 0 : data.deal) === null || _c === void 0 ? void 0 : _c.id
                                }
                            }
                        }
                    ]
                });
                alert.present({
                    title: React.createElement("p", null, t('Task sheet data has been generated.'))
                });
            }
            catch (error) {
                alert.present({ error });
            }
        });
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    const onSuccess = () => {
        setProcessing(false);
        alert.present({
            title: (React.createElement("p", null,
                customLabels['Deal'][language],
                " ",
                React.createElement("strong", null, dealTitle),
                ' ',
                t('has been updated.'),
                "."))
        });
    };
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    const onFailure = (error) => {
        alert.present({ error });
    };
    useEffect(() => {
        var _a;
        setDealTitle((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.title);
    }, [(_l = data === null || data === void 0 ? void 0 : data.deal) === null || _l === void 0 ? void 0 : _l.title]);
    useEffect(() => {
        var _a;
        setDealStatus((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.status);
    }, [(_m = data === null || data === void 0 ? void 0 : data.deal) === null || _m === void 0 ? void 0 : _m.status]);
    useEffect(() => {
        var _a;
        setDealStage((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.stage);
    }, [(_o = data === null || data === void 0 ? void 0 : data.deal) === null || _o === void 0 ? void 0 : _o.stage]);
    /**
     * @function updateDealHeader
     * @since 1.0.0
     * @hidden
     */
    const updateDealHeader = (input) => __awaiter(this, void 0, void 0, function* () {
        var _46;
        if (!((_46 = data === null || data === void 0 ? void 0 : data.deal) === null || _46 === void 0 ? void 0 : _46.id))
            return;
        const previousStatus = dealStatus;
        const previousStage = dealStage;
        if (input.status)
            setDealStatus(input.status);
        if (input.stage)
            setDealStage(input.stage);
        try {
            yield apollo.mutate({
                mutation: UpdateDealHeaderMutation,
                variables: {
                    input: Object.assign({ id: data.deal.id, newVersion: false }, input)
                },
                refetchQueries: [
                    {
                        query: DealDetailsQuery,
                        variables: { input: { id: data.deal.id } }
                    }
                ],
                awaitRefetchQueries: true
            });
            alert.present({
                title: (React.createElement("p", null,
                    React.createElement("strong", null, t('Quote')),
                    " ",
                    t('has been updated.')))
            });
        }
        catch (error) {
            setDealStatus(previousStatus);
            setDealStage(previousStage);
            alert.present({ error });
        }
    });
    const dealStageOptions = useDealStageOptions();
    const hasStagesForStatus = useHasStagesForStatus(dealStatus);
    const stage = dealStageOptions.find((stage) => { var _a; return stage.value === ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.stage); });
    const statusType = ((_p = data === null || data === void 0 ? void 0 : data.deal) === null || _p === void 0 ? void 0 : _p.type) === 'AGREEMENT' ? 'AGREEMENT' : 'DEAL';
    const status = getStatusOptions(statusType).find((status) => { var _a; return status.value === ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.status); });
    const context = {
        deal: (_q = data === null || data === void 0 ? void 0 : data.deal) !== null && _q !== void 0 ? _q : null,
        setDeal,
        dealItemFields,
        setDealItemFields: () => { },
        dealItemConfigurationFields,
        setDealItemConfigurationFields: () => { }
    };
    return (React.createElement(DealDetailContext.Provider, { value: context },
        React.createElement(Screen, { className: "deal-details-screen", ready: ready },
            React.createElement(Header, null,
                React.createElement(ScreenBar, { infos: {
                        title: isOrderIn ? t('Order Details') : t('Quote Details'),
                        infos: isOrderIn ? t('Order Details') : t('Quote Details'),
                        route: isOrderIn ? 'order.manage' : 'deal.manage'
                    }, trail: {
                        title: isOrderIn ? t('Orders') : t('Quotes'),
                        infos: isOrderIn ? t('Orders') : t('Quotes'),
                        route: isOrderIn ? 'order.manage' : 'deal.manage'
                    } },
                    React.createElement(FormAction, null,
                        React.createElement(Button, { style: "outline", label: t('Cancel'), route: "deal.manage" }),
                        ((_r = data === null || data === void 0 ? void 0 : data.deal) === null || _r === void 0 ? void 0 : _r.orderIn) ? (React.createElement(Button, { form: "order-details-form", style: "primary", label: t('Save'), processing: processing, submit: true })) : (React.createElement(Button, { form: "deal-details-form", style: "primary", label: `${t('Save')}`, processing: processing, submit: true }))))),
            React.createElement(Content, null,
                React.createElement(MutationForm, { name: "deal-details-form", id: "deal-details-form", mutation: UpdateDealMutation, onProcess: onProcess, onSuccess: onSuccess, onFailure: onFailure },
                    React.createElement("div", { className: "deal-details-container-header" },
                        React.createElement("div", { className: "deal-details-container-title" },
                            React.createElement("div", { className: "deal-details-deal-title" }, dealTitle),
                            !((_s = data === null || data === void 0 ? void 0 : data.deal) === null || _s === void 0 ? void 0 : _s.orderIn) && (React.createElement(Button, { style: "picto", picto: "pencil", onPress: onClickEdit }))),
                        openModalEdit && (React.createElement(DealTitleModalEdit, { onClose: onCloseEdit, dealTitle: dealTitle === null || dealTitle === void 0 ? void 0 : dealTitle.toString(), onConfirm: onConfirmEdit })),
                        React.createElement("div", { className: "deal-details-container-actions" },
                            user.isContactUser() &&
                                ((_t = data === null || data === void 0 ? void 0 : data.deal) === null || _t === void 0 ? void 0 : _t.stage) === 'PENDING_APPROVAL' && (React.createElement(Status, { className: "deal-details-deal-status", color: "orange", label: t('Your deal is pending approval') })),
                            !user.isContactUser() &&
                                ((_u = data === null || data === void 0 ? void 0 : data.deal) === null || _u === void 0 ? void 0 : _u.stage) === 'PENDING_APPROVAL' && (React.createElement(React.Fragment, null,
                                React.createElement(Button, { style: "secondary", picto: "check", label: t('Approve'), onPress: () => onClickApprove() }),
                                React.createElement(Button, { style: "secondary", picto: "times", label: t('Reject'), onPress: () => onClickReject() }))),
                            ((_v = data === null || data === void 0 ? void 0 : data.deal) === null || _v === void 0 ? void 0 : _v.stage) !== 'PENDING_APPROVAL' && (React.createElement("div", { className: "deal-details-deal-status" }, user.isContactUser() ? (React.createElement(React.Fragment, null,
                                React.createElement(Status, { color: (_w = status === null || status === void 0 ? void 0 : status.color) !== null && _w !== void 0 ? _w : 'green', label: (_x = status === null || status === void 0 ? void 0 : status.label) !== null && _x !== void 0 ? _x : 'N/A' }),
                                React.createElement(Status, { color: (_y = stage === null || stage === void 0 ? void 0 : stage.color) !== null && _y !== void 0 ? _y : 'green', label: (_z = stage === null || stage === void 0 ? void 0 : stage.label) !== null && _z !== void 0 ? _z : 'N/A' }))) : ((_0 = data === null || data === void 0 ? void 0 : data.deal) === null || _0 === void 0 ? void 0 : _0.orderIn) ? (React.createElement(React.Fragment, null,
                                React.createElement(Status, { color: "green", label: t('Order in') }))) : (React.createElement(React.Fragment, null,
                                React.createElement(StatusSelect, { type: statusType, value: dealStatus, onChange: (status) => {
                                        if (status !== dealStatus) {
                                            updateDealHeader({ status });
                                        }
                                    }, disabled: ((_1 = data === null || data === void 0 ? void 0 : data.deal) === null || _1 === void 0 ? void 0 : _1.orderIn) ? true : false }),
                                hasStagesForStatus && (React.createElement(StageSelect, { type: "DEAL", status: dealStatus, value: dealStage, onChange: (stage) => {
                                        if (stage !== dealStage) {
                                            updateDealHeader({ stage });
                                        }
                                    }, disabled: ((_2 = data === null || data === void 0 ? void 0 : data.deal) === null || _2 === void 0 ? void 0 : _2.orderIn) ? true : false })),
                                ((_3 = data === null || data === void 0 ? void 0 : data.deal) === null || _3 === void 0 ? void 0 : _3.id) && data.deal.status === 'LOST' && (React.createElement(RefusalReasonSelect, { dealId: data.deal.id, value: (_6 = (_5 = (_4 = data === null || data === void 0 ? void 0 : data.deal) === null || _4 === void 0 ? void 0 : _4.refusalReason) === null || _5 === void 0 ? void 0 : _5.id) !== null && _6 !== void 0 ? _6 : null, disabled: ((_7 = data === null || data === void 0 ? void 0 : data.deal) === null || _7 === void 0 ? void 0 : _7.orderIn) ? true : false, refetchQueries: [
                                        {
                                            query: DealDetailsQuery,
                                            variables: { input: { id: data.deal.id } }
                                        }
                                    ] })))))),
                            externalData &&
                                externalDataValues.map((item) => (React.createElement("div", { className: "deal-details-container-button", key: item.asset },
                                    React.createElement(Button, { style: "normal", badge: "arrow-up-right-from-square", size: "small", label: item.asset, className: "deal-details-button", onPress: () => {
                                            window.open(item.value.url, '_blank');
                                        } }))))))),
                React.createElement("div", { className: "deal-details-container-info" },
                    React.createElement("div", { className: "deal-details-container-text-info" },
                        React.createElement("div", { className: "deal-details-container-info-item" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, isOrderIn ? t('Order') : t('Deal')),
                            React.createElement("div", { className: "deal-details-text-info-value" }, isOrderView
                                ? (_8 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.number) !== null && _8 !== void 0 ? _8 : (_9 = data === null || data === void 0 ? void 0 : data.deal) === null || _9 === void 0 ? void 0 : _9.number
                                : (_10 = data === null || data === void 0 ? void 0 : data.deal) === null || _10 === void 0 ? void 0 : _10.number)),
                        React.createElement("div", { className: "deal-details-container-info-item" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Date')),
                            React.createElement("div", { className: "deal-details-text-info-value" },
                                React.createElement(DateTime, { value: isOrderView
                                        ? (_11 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.date) !== null && _11 !== void 0 ? _11 : (_12 = data === null || data === void 0 ? void 0 : data.deal) === null || _12 === void 0 ? void 0 : _12.date
                                        : (_13 = data === null || data === void 0 ? void 0 : data.deal) === null || _13 === void 0 ? void 0 : _13.date, y: "numeric", m: "numeric", d: "numeric" }))),
                        React.createElement("div", { className: "deal-details-container-info-item" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Client')),
                            React.createElement("div", { className: "deal-details-text-info-value" }, (_15 = (_14 = data === null || data === void 0 ? void 0 : data.deal) === null || _14 === void 0 ? void 0 : _14.contact) === null || _15 === void 0 ? void 0 : _15.fullname)),
                        React.createElement("div", { className: "deal-details-container-info-item" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Organization')),
                            React.createElement("div", { className: "deal-details-text-info-value" }, (_17 = (_16 = data === null || data === void 0 ? void 0 : data.deal) === null || _16 === void 0 ? void 0 : _16.client) === null || _17 === void 0 ? void 0 : _17.name)),
                        React.createElement("div", { className: "deal-details-container-info-item" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Value')),
                            React.createElement("div", { className: "deal-details-text-info-value" },
                                React.createElement(Money, { value: isOrderView
                                        ? (_18 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.total) !== null && _18 !== void 0 ? _18 : 0
                                        : (_19 = data === null || data === void 0 ? void 0 : data.deal) === null || _19 === void 0 ? void 0 : _19.subtotal }),
                                React.createElement("span", { className: "deal-details-currency" },
                                    ' ', (_20 = data === null || data === void 0 ? void 0 : data.deal) === null || _20 === void 0 ? void 0 :
                                    _20.currency.code))),
                        React.createElement(Requires, { permission: "deal.plannedDate" },
                            React.createElement("div", { className: "deal-details-container-info-item" },
                                React.createElement("div", { className: "deal-details-text-info-title" }, t('Planned Date')),
                                React.createElement("div", { className: "deal-details-text-info-value" }, (data === null || data === void 0 ? void 0 : data.deal)
                                    ? formatPlannedDateLabel(data.deal.plannedDateStart, data.deal.plannedDateEnd)
                                    : null)))),
                    React.createElement("div", { className: "deal-detail-actions " },
                        React.createElement("div", { className: "deal-details-actions-container--deal" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Deal')),
                            React.createElement("div", { className: "deal-details-actions-container--deal-items" },
                                React.createElement(Requires, { permission: "deal.update" },
                                    React.createElement("div", { className: "deal-details-container-button" },
                                        React.createElement(Button, { style: "picto", picto: "pen-to-square", size: "small", onPress: onClickEditDeal, className: "deal-details-button" }),
                                        React.createElement(Text, { className: "deal-details-edit-value", value: t('Edit') }))),
                                React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(Button, { style: "picto", picto: "eye", size: "small", className: "deal-details-button", onPress: onPressPreview }),
                                    React.createElement(Text, { className: "deal-details-link-value", value: t('Preview this quote') })),
                                React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(Button, { style: "picto", picto: "link", size: "small", className: "deal-details-button", onPress: onPressCopy }),
                                    React.createElement(Text, { className: "deal-details-link-value", value: t('Copy deal link') })),
                                hasPDF === 'TRUE' && (React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(PdfDownloadButton, { dealId: (_21 = data === null || data === void 0 ? void 0 : data.deal) === null || _21 === void 0 ? void 0 : _21.id, className: "deal-details-button" }),
                                    React.createElement(Text, { className: "deal-details-pdf-value", value: t('Download PDF') }))),
                                React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(ExportButton, { customClass: "deal-details-button", exportMutation: ExportDealsMutation, entityIds: ((_22 = data === null || data === void 0 ? void 0 : data.deal) === null || _22 === void 0 ? void 0 : _22.id) ? [(_23 = data === null || data === void 0 ? void 0 : data.deal) === null || _23 === void 0 ? void 0 : _23.id] : [] }),
                                    React.createElement(Text, { className: "deal-details-csv-value", value: t('Export CSV') })),
                                React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(Button, { style: "picto", picto: "clipboard", size: "small", className: "deal-details-button", onPress: onPressCopyID }),
                                    React.createElement(Text, { className: "deal-details-link-value", value: t('Copy deal ID') })),
                                ((_24 = data === null || data === void 0 ? void 0 : data.deal) === null || _24 === void 0 ? void 0 : _24.plannedDateStart) && (React.createElement(Requires, { permission: "calendar.manage" },
                                    React.createElement("div", { className: "deal-details-container-button" },
                                        React.createElement(Button, { style: "picto", picto: "calendar-plus", size: "small", className: "deal-details-button", onPress: onClickSendInvite }),
                                        React.createElement(Text, { className: "deal-details-link-value", value: t('Add to calendar') })))))),
                        React.createElement("div", { className: "deal-details-actions-container--order" },
                            React.createElement("div", { className: "deal-details-text-info-title" }, t('Order')),
                            React.createElement("div", { className: "deal-details-actions-container--order-items" },
                                React.createElement(Requires, { permission: ['order.manage', 'order.update'] }, !((_25 = data === null || data === void 0 ? void 0 : data.deal) === null || _25 === void 0 ? void 0 : _25.orderIn) && (React.createElement("div", { className: "deal-details-container-button" },
                                    React.createElement(Button, { style: "picto", picto: "file-contract", size: "small", onPress: onClickOrderIn, disabled: !!((_26 = data === null || data === void 0 ? void 0 : data.deal) === null || _26 === void 0 ? void 0 : _26.orderIn), className: ((_27 = data === null || data === void 0 ? void 0 : data.deal) === null || _27 === void 0 ? void 0 : _27.orderIn)
                                            ? 'deal-details-button-confirmation deal-details-button'
                                            : 'deal-details-button' }),
                                    React.createElement(Text, { className: "deal-details-order-value", value: t('Transfer of quote to order') })))),
                                ((_28 = data === null || data === void 0 ? void 0 : data.deal) === null || _28 === void 0 ? void 0 : _28.orderIn) && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "deal-details-container-button" },
                                        React.createElement(Button, { style: "picto", picto: "file-xmark", size: "small", onPress: onClickCancelOrder, className: "deal-details-button" }),
                                        React.createElement(Text, { className: "deal-details-order-value", value: t('Cancel order') })),
                                    React.createElement("div", { className: "deal-details-container-button" },
                                        React.createElement(Button, { style: "picto", picto: "paper-plane", size: "small", onPress: onClickResendOrderConfirmation, className: "deal-details-button" }),
                                        React.createElement(Text, { className: "deal-details-order-value", value: t('Resend order confirmation') })),
                                    React.createElement("div", { className: "deal-details-container-button" },
                                        React.createElement(Button, { className: "deal-details-button file-button", style: "bordered", picto: 'file-pdf', onPress: () => {
                                                var _a, _b;
                                                const confirmationUrl = (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id)
                                                    ? `/orders/confirmation/${(_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id}?order=${currentOrder.id}`
                                                    : `/orders/confirmation/${(_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.id}`;
                                                window.open(confirmationUrl, '_blank');
                                            } }),
                                        React.createElement(Text, { className: "deal-details-order-value", value: t('Download PDF') })))))))),
                openModalApprove && (React.createElement(DealApproveModal, { onClose: onCloseApprove, onConfirm: onConfirmApprove })),
                openModalReject && (React.createElement(DealRejectModal, { onClose: onCloseReject, onConfirm: onConfirmReject })),
                openModalOrderIn && (React.createElement(DealOrderInModal, { onClose: onCloseOrderIn, 
                    // dealTitle={dealTitle?.toString()}
                    onConfirm: onConfirmOrderIn })),
                openModalCancelOrder && (React.createElement(DealCancelOrderModal, { canRefund: user.can('deal.payment.manage'), payments: (_30 = (_29 = data === null || data === void 0 ? void 0 : data.deal) === null || _29 === void 0 ? void 0 : _29.payments) !== null && _30 !== void 0 ? _30 : [], onClose: onCloseCancelOrder, onConfirm: onConfirmCancelOrder })),
                openModalCancelSignature && (React.createElement(DealCancelSignatureModal, { onClose: onCloseCancelSignature, onConfirm: onConfirmCancelSignature })),
                openModalReassignOnLoad && (React.createElement(DealReassignOnLoadModal, { onClose: onCloseReassignOnLoad, onConfirm: onConfirmReassignOnLoad, currentUserName: (_32 = (_31 = data === null || data === void 0 ? void 0 : data.deal) === null || _31 === void 0 ? void 0 : _31.user) === null || _32 === void 0 ? void 0 : _32.fullname })),
                React.createElement(TabPanelGroup, { style: "plain", syncUrl: true },
                    isOrderView ? (React.createElement(TabPanel, { label: t('Order') },
                        React.createElement(DealOrderPane, { deal: data === null || data === void 0 ? void 0 : data.deal, order: currentOrder, commandOnly: true }),
                        orderId && React.createElement(OrderVoucherFieldsPanel, { orderId: orderId }))) : (React.createElement(TabPanel, { label: customLabels['Deal'][language] },
                        React.createElement(DealInformationPane, { data: data === null || data === void 0 ? void 0 : data.deal }),
                        React.createElement(DealSummaryPanel, { deal: data === null || data === void 0 ? void 0 : data.deal, staticMode: true }))),
                    !isOrderView &&
                        ((_33 = data === null || data === void 0 ? void 0 : data.deal) === null || _33 === void 0 ? void 0 : _33.orders) &&
                        data.deal.orders.length > 0 ? (React.createElement(TabPanel, { label: t('Elements') }, [...data.deal.orders]
                        .sort((a, b) => { var _a, _b; return String((_a = a.date) !== null && _a !== void 0 ? _a : '').localeCompare(String((_b = b.date) !== null && _b !== void 0 ? _b : '')); })
                        .map((order) => (React.createElement(DealOrderPane, { key: order.id, deal: data.deal, order: order }))))) : null,
                    React.createElement(TabPanel, { label: customLabels['Contact'][language] },
                        React.createElement(DealContactPane, { data: data === null || data === void 0 ? void 0 : data.deal })),
                    !isOrderView ? (React.createElement(TabPanel, { label: t('Approval') },
                        React.createElement(DealApprovalPane, { data: data === null || data === void 0 ? void 0 : data.deal, onCancelSignature: onClickCancelSignature }))) : null,
                    React.createElement(Requires, { permission: "deal.payment.manage" },
                        React.createElement(TabPanel, { label: t('Payments') },
                            React.createElement(DealPaymentPanel, { deal: data === null || data === void 0 ? void 0 : data.deal, dealTotal: isOrderView
                                    ? (_34 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.total) !== null && _34 !== void 0 ? _34 : 0
                                    : (_35 = data === null || data === void 0 ? void 0 : data.deal) === null || _35 === void 0 ? void 0 : _35.total, orderId: isOrderView ? orderId : undefined, editable: false, hasDeposit: hasDeposit, showPaymentDetails: true }))),
                    React.createElement(TabPanel, { label: t('Information') },
                        React.createElement(DealAdditionalInformationPane, { deal: data === null || data === void 0 ? void 0 : data.deal, dataFieldGroup: (_36 = dataFieldGroup === null || dataFieldGroup === void 0 ? void 0 : dataFieldGroup.fieldGroups.filter((fieldGroup) => fieldGroup.category === 'DEAL')) !== null && _36 !== void 0 ? _36 : [] })),
                    !user.isContactUser() && (React.createElement(TabPanel, { label: t('Changelog') },
                        React.createElement(DealChangelogPane, null))))))));
}
/**
 * @component DealDetailContext
 * @since 1.0.0
 */
export const DealDetailContext = createContext({
    deal: null,
    setDeal() { },
    dealItemFields: [],
    setDealItemFields() { },
    dealItemConfigurationFields: [],
    setDealItemConfigurationFields() { }
});
/**
 * @function useDealDetailContext
 * @since 1.0.0
 */
export function useDealDetailContext() {
    return useContext(DealDetailContext);
}
/**
 * @const DealDetailsScreenInfos
 * @since 1.0.0
 */
export const DealDetailsScreenInfos = {
    title: t('Deal Details'),
    infos: t('Deal Details'),
    route: 'deal.details'
};
